import APP_ROUTES from '@cp/src/layout/Routes';
import { createQueryParams } from '@cp/src/utils/QueryParamsHelper';
import { navigateToCaseDetails } from '@cp/src/utils/commonUtils';
import { dispatch, navigate } from '@cp/src/utils/ApiHelper';
import { RecommendedCaseData } from './types';
import { setCurrentRecommendedCase } from './reducer';

export const navigateToCase = (currentRecommendedCase: RecommendedCaseData) => {
  if (currentRecommendedCase) {
    dispatch(setCurrentRecommendedCase(currentRecommendedCase));
    const { entityId, customerReferenceId, caseReferenceId, businessVertical } =
      currentRecommendedCase;

    const searchParams = createQueryParams({
      caseRecommendation: { hasContext: 'true' }
    });
    navigateToCaseDetails(
      customerReferenceId || '',
      entityId || '',
      caseReferenceId || '',
      businessVertical || '',
      navigate,
      APP_ROUTES.CASE_DETAIL.path,
      searchParams
    );
  }
};

export const DEFAULT_LIMIT_FOR_RECOMMENDED_CASES = 20;

export const DEFAULT_OFFSET_FOR_RECOMMENDED_CASES = 0;
